import { render, staticRenderFns } from "./PauseSubscriptionConfirm.vue?vue&type=template&id=8c68c7fa"
import script from "./PauseSubscriptionConfirm.vue?vue&type=script&lang=js"
export * from "./PauseSubscriptionConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports